import * as Yup from "yup"

const LoginNewPasswordValidationSchema = Yup.object().shape({
  password: Yup.string().min(6).required("Password is required."),
})

export default LoginNewPasswordValidationSchema
